<template>
  <div>
    <label>
      <b>{{ $t('chooseDateAndTime') }}</b>
    </label>
    <div class="d-flex justify-content-between">
      <WCFormGroup class="wc-select">
        <WCSelect
          v-model="reservation.date"
          @input="change($event, times[0].start)"
          class="bg-light"
          :aria-label="$t('chooseDate')"
        >
          <option v-for="(date, di) in sortedDateOptions" :key="di" :value="date.date">
            {{ date.date | dayOfWeek }}, {{ date.date | formatMonthDay }}</option
          >
        </WCSelect>
      </WCFormGroup>

      <WCFormGroup class="wc-select">
        <WCSelect
          v-model="reservation.time"
          @input="change(reservation.date, $event)"
          class="bg-light"
          :aria-label="$t('chooseTime')"
        >
          <option v-for="(time, ti) in times" :key="ti" :value="time.start">
            {{ time.start | formatTime }} - {{ time.end | formatTime }}
          </option>
        </WCSelect>
      </WCFormGroup>
    </div>
  </div>
</template>

<script>
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCSelect from '@/modules/forms/components/WCSelect/WCSelect.vue';
import { dynamicSort } from '@/utils';

export default {
  components: { WCFormGroup, WCSelect },
  model: {
    prop: 'reservation',
    event: 'change',
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    reservation: {
      type: Object,
    },
  },
  computed: {
    times() {
      const value = this.options.find(date => date.date === this.reservation.date);
      let sortedTimes = [];
      if (value?.times?.length > 0) {
        sortedTimes = dynamicSort(value.times, 'start'); // Sort time options in ascending order
      }
      return sortedTimes;
    },
    /**
     * Sort date options in ascending order
     */
    sortedDateOptions() {
      return dynamicSort(this.options, 'date');
    },
  },
  methods: {
    change(date, time) {
      this.$emit('change', { date, time });
    },
  },
};
</script>

<style lang="scss" scoped>
.wc-select {
  width: 45%;
}
</style>
